(function() {
    'use strict';

    angular
        .module('nasracApp')
        .controller('NasracAdminUserAccountDetailController', NasracAdminUserAccountDetailController);

    NasracAdminUserAccountDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'NasracAdminUserAccount', 'NasracAdminCustomerAccount'];

    function NasracAdminUserAccountDetailController($scope, $rootScope, $stateParams, previousState, entity, NasracAdminUserAccount, NasracAdminCustomerAccount) {
        var vm = this;

        vm.nasracAdminUserAccount = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('nasracApp:nasracAdminUserAccountUpdate', function(event, result) {
            vm.nasracAdminUserAccount = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
